const RES = window.RES,
      $   = jQuery;

import ScriptsLoader from '../loaders/AsyncScriptsLoader';

export default class RegionPicker {
    constructor() {
        this.root = $('#region-picker');
        this.siteFooter = $('#siteFooter');
        this.siteFooterContainer = this.siteFooter.parent();
        this.footerContainer = this.root.find('.regions-footer');

        this.scriptsLoader = new ScriptsLoader([
            'assets/world-map/d3.min.js',
            'assets/world-map/topojson.min.js',
            'assets/world-map/datamaps.world.min.js',
            'assets/world-map/d3-array.v1.min.js',
            'assets/world-map/d3-geo.v1.min.js',
            'assets/world-map/d3-geo-projection.v2.min.js',
        ].map(path => RES.global('templateURI') + '/' + path));

        this._mapInitialized = false;
        this._blocked = false;
        this._visible = false;

        this.mapContainer = this.root.find('#regions-picker-map');
        this.blogs = this.root.find('.regions-palette-blog').toArray().map(b => {
            return {
                el: $(b),
                codes: ($(b).data('country-codes') || []).filter(code => code),
            };
        });
        this.countryCodes = this.blogs
            .reduce((res, entry) => {
                res.splice(res.length - 1, 0, ...entry.codes);
                entry.codes.forEach(code => {
                    if (res.indexOf(code) === -1) {
                        res.push(code);
                    }
                });
                return res;
            }, []);

        this.map = null;
        this.bindControls();
        this.hide();
    }

    bindControls() {
        $(document.body).on('regionPicker/show', this.show.bind(this));
        $(document.body).on('regionPicker/hide', this.hide.bind(this));
        $(document.body).on('regionPicker/toggle', this.toggle.bind(this));
        this.root.find('.regions-header-current').on('click', this.hide.bind(this));
    }

    initMap() {

        let props = {
            element: this.mapContainer.get(0),
            responsive: true,
            // projection: 'mercator',
            setProjection: (element, options) => {

                // const larrivee = d3.geoLarrivee()
                //   .center([21, 0])
                //   .scale(118)
                //   .translate([element.offsetWidth / 2, element.offsetHeight / 1.6])

                // adjust map scale based on window width
                let coef = ((window.innerWidth / 1920) + 2) / 3;
                let scale = window.innerWidth / (10 * coef);

                const times = d3.geoTimes()
                    .center([18, 0])
                    .scale(scale)
                    .translate([element.offsetWidth / 2, element.offsetHeight / 1.7]);

                return {
                    times,
                    path: d3.geo.path().projection(times),
                };
            },
            fills: {
                defaultFill: '#5a5a5a',
                FEATURED: '#ffd300',
            },
            data: {},
            geographyConfig: {
                borderColor: '#9e9e9e',
                borderWidth: 0.5,
                popupOnHover: false,
                highlightOnHover: false,
            },
            done: datamap => {
                datamap.svg.selectAll('.datamaps-subunit').on('click', geo => {
                    let url = '';
                    this.countryCodes.forEach(cc => {
                        if (cc === geo.id) {
                            url = this.blogs
                                .filter(data => {
                                    return data.codes.includes(geo.id);
                                })
                                .forEach(data => {
                                    data.el
                                        .find('.regions-palette-blog-link')
                                        .attr('href');
                                });
                        }
                    });
                    if (url) {
                        window.open(url, '_self');
                    }
                });
            },
        };

        this.countryCodes.forEach(code => {
            props.data[code] = {
                fillKey: 'FEATURED',
                code,
            };
        });

        this.map = new Datamap(props);

        let units = this.mapContainer.find('.datamaps-subunit');

        let availableUnits = units.filter((i, el) => {
            const data = $(el).data('info');
            return data && data.fillKey === 'FEATURED';
        }).addClass('s-available');

        let binds = this.blogs.map(blog => {
            return {
                blog,
                unit: availableUnits.filter(blog.codes.length ? '.' + blog.codes.join(', .') : ''),
            };
        });

        binds.forEach(({ blog, unit }) => {
            blog.el
                .on('mouseenter', () => {
                    availableUnits.removeClass('s-selected');
                    unit.addClass('s-selected');
                })
                .on('mouseleave', () => unit.removeClass('s-selected'));
            unit.toArray().map(u => $(u)).forEach(u => {
                const data          = u.data('info'),
                      singleMatch   = this.blogs.find(b => {
                          return data.code === b.codes[0];
                      }),
                      multipleMatch = this.blogs.filter(b => b.codes.includes(data.code));

                u.on('mouseenter', () => {
                    this.blogs.forEach(blog => blog.el.removeClass('s-selected'));
                    if (singleMatch) {
                        singleMatch.el.addClass('s-selected');
                    } else if (multipleMatch.length) {
                        multipleMatch.forEach(b => b.el.addClass('s-selected'));
                    }
                });
                u.on('mouseleave', () => blog.el.removeClass('s-selected'));
                u.on('click', () => {
                    let url = '';
                    if (singleMatch) {
                        url = singleMatch.el.data('url');
                    } else if (multipleMatch.length) {
                        url = multipleMatch[0].el.data('url');
                    }
                    if (url) {
                        window.location.href = url;
                    }
                });
            });
        });

        this.root.find('.regions-palette-global')
            .on('mouseenter', () => availableUnits.addClass('s-selected'))
            .on('mouseleave', () => availableUnits.removeClass('s-selected'));

        $(window).on('resize orientationchange', () => {
            this.mapContainer.children('svg')
                .attr('width', this.mapContainer.width())
                .attr('height', this.mapContainer.height())
                .attr('data-width', this.mapContainer.width())
                .attr('data-height', this.mapContainer.height());
            this.map.resize();
        });

        this._mapInitialized = true;
    }

    toggle() {
        this._visible ? this.hide() : this.show();
    }

    show() {

        if (!(this._blocked || this._mapInitialized)) {
            this.scriptsLoader.onLoad(() => this.initMap());
            this.scriptsLoader.load();
        }

        this.footerContainer.append(this.siteFooter);
        this.root.addClass('regions--visible').removeClass('regions--hidden').attr('aria-hidden', 'false');
        this.root.find('a, button').attr('tabindex', 0);
        this._visible = true;
    }

    hide() {
        setTimeout(() => {
            this.siteFooterContainer.append(this.siteFooter);
        }, 100);
        this.root.removeClass('regions--visible').addClass('regions--hidden').attr('aria-hidden', 'true');
        this.root.find('a, button').attr('tabindex', -1);
        this._visible = false;
    }

    block() {
        this._blocked = true;
    }

    release() {
        this._blocked = false;
    }
}
